export default __webpack_public_path__ + "static/O0201-07a3357ae18615078493eab0ecd7ee5e.png";